import { __decorate, __metadata } from "tslib";
import { injectable } from "inversify";
import { UserLocalizationConfigStore } from "./UserLocalizationConfigStore";
import { LocalizationOptionsStore } from "../options/LocalizationOptions";
import { UserLocaleResolver } from "./resolver/UserLocaleResolver";
let UserLocalizationConfigService = class UserLocalizationConfigService {
    constructor(store, options, userLocaleResolver) {
        this.store = store;
        this.options = options;
        this.userLocaleResolver = userLocaleResolver;
    }
    async initializeUserConfiguration() {
        if (!this.store.value.selectedLocale)
            await this.resolveCurrentLocale();
        if (!this.store.value.selectedCurrency)
            this.resolveCurrentCurrency();
    }
    async resolveCurrentLocale() {
        const resolved = await this.userLocaleResolver.resolve();
        if (resolved)
            this.store.setCurrentLocale(resolved);
    }
    resolveCurrentCurrency() {
        const { defaultCurrency } = this.options.value;
        this.store.setCurrentCurrency(defaultCurrency);
    }
};
UserLocalizationConfigService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [UserLocalizationConfigStore,
        LocalizationOptionsStore,
        UserLocaleResolver])
], UserLocalizationConfigService);
export { UserLocalizationConfigService };
//# sourceMappingURL=UserLocalizationConfigService.js.map